<template>
  <section>
    <p class="eyebrow">{{ material.title }} · 문항 {{ index + 1 }} / {{ material.questions.length }}</p>
    <form @submit.prevent="$emit('submit', answer.trim())">
      <h2 id="question-heading">{{ question.prompt }}</h2>
      <fieldset v-if="question.type === 'singleChoice'" :disabled="busy">
        <legend class="sr-only">{{ question.prompt }}</legend>
        <label v-for="option in question.options" :key="option.value" class="option">
          <input v-model="answer" type="radio" :value="option.value" name="answer" :required="required" /> {{ option.label }}
        </label>
      </fieldset>
      <template v-else>
        <label class="sr-only" for="text-answer">응답</label>
        <textarea id="text-answer" v-model="answer" :disabled="busy" :required="required" maxlength="5000" rows="6" placeholder="응답을 입력해주세요." />
      </template>
      <p class="notice">{{ required ? '응답은 필수입니다. ' : '' }}제출 후에는 이 문항으로 돌아갈 수 없습니다.</p>
      <button type="button" class="secondary" :aria-expanded="expanded" aria-controls="reference-material" :disabled="busy" @click="toggle">{{ expanded ? '읽기 자료 접기' : '읽기 자료 다시 보기' }}</button>
      <div v-if="expanded" id="reference-material" class="reference"><ReadingMaterial :material="material" heading-id="reference-heading" /></div>
      <button type="submit" :disabled="busy || (required && !answer.trim())">{{ busy ? '저장 중…' : (last ? '응답 저장 · 연구 완료' : '응답 저장 · 다음') }}</button>
    </form>
  </section>
</template>
<script>
import ReadingMaterial from './ReadingMaterial.vue';
export default {
  components: { ReadingMaterial },
  props: { material: Object, question: Object, index: Number, busy: Boolean, required: Boolean, last: Boolean },
  emits: ['submit', 'reference'],
  data: () => ({ answer: '', expanded: false }),
  methods: { toggle() { this.expanded = !this.expanded; this.$emit('reference', this.expanded); } }
};
</script>
